import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
};
